import { render, staticRenderFns } from "./offline.vue?vue&type=template&id=4960cb97&"
import script from "./offline.vue?vue&type=script&lang=js&"
export * from "./offline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports